import { gql, useMutation } from '@apollo/client';

import { GET_CURRENT_ACCOUNT } from 'src/hooks/accounts/get-current-account.hook';

const CHANGE_CUSTOMER_LANGUAGE = gql`
  mutation ChangeLanguage($language: String!) {
    changeProfileLanguage(language: $language) {
      language
    }
  }
`;

export const useChangeLanguage = () => {
  const [changeLanguage] = useMutation(CHANGE_CUSTOMER_LANGUAGE, {
    refetchQueries: [GET_CURRENT_ACCOUNT],
  });

  return changeLanguage;
};
